import { Component, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { QzTrayService } from '../../../qz-tray.service';
import moment from 'moment';
import {
  Labels,
  ProductionHistory,
  UserPermissionsModel,
  WarehouseLocationsModels,
  BulkDeleteHistoryResponse,
  FailedToDeleteSerial
} from '../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import { BreadcrumbService } from '../../../Services/breadcrumb.service';
import { CustomToastsService } from '../../../Services/custom-toasts.service';
import * as qz from 'qz-tray';
import { sha256 } from 'js-sha256';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LabelEntityType, PageSizes } from 'src/app/Services/enum';

@Component({
  selector: 'app-prod-history',
  templateUrl: './prod-history.component.html',
  styleUrls: ['./prod-history.component.css']
})
export class ProdHistoryComponent implements OnDestroy {
  @ViewChild('tagButton') tagButton?: ElementRef<HTMLElement>;
  @ViewChild('checkBtn') checkPrice?: ElementRef<HTMLElement>;
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  productionHistory: Array<ProductionHistory> = [];
  DeptCatArray: Array<ProductionHistory> = [];
  searchBarcode: Array<ProductionHistory> = [];
  DeptCatArray1: Array<ProductionHistory> = [];
  DeptCatArrayForFilters: Array<ProductionHistory> = [];
  DeptArrayForDepartment: Array<ProductionHistory> = [];
  DeptArrayForCategory: Array<ProductionHistory> = [];
  DeptArrayForColors: Array<ProductionHistory> = [];
  printHistory: Array<ProductionHistory> = [];
  filterDepartmentIDs: number[] = [];
  filterCategoriesIDs: number[] = [];
  selectedDeptForFiletr: number[] = [];
  filterColorIDs: number[] = [];
  formatLabels: Array<Labels> = [];
  noData: boolean = false;
  isLoading: boolean = false;
  isHistory: boolean = true;
  filterName: string = 'Department';
  barcodes: string = '';
  startingDate: string = '';
  endingDate: string = '';
  showDates: boolean = false;
  isPrinting: boolean = false;
  printersList: Array<string> = [];
  printItems: any[] = [];
  equalsZero: boolean = false;
  equalsZeroCnt: number = 0;
  greaterZero: boolean = false;
  greaterZeroCnt: number = 0;
  deleteButtonClickedWithSelection: boolean = false;
  printCnt: boolean = true;
  delIds: string[] = [];
  zplCode: string = '';
  activeTag: number = 0;
  disableEdit: boolean = true;
  editableRowIndex: number | null = null;
  lastQty: number = 0;
  printerType: number = 0;
  previewZplCode: string = '';
  previewTagSize: string = '';
  startDate: any = '';
  endDate: any = '';
  locations: Array<WarehouseLocationsModels> = [];
  selectedIdToDelete: number = 0;
  isFilterModalOpen: boolean = false;
  private searchSubject = new Subject<string>();
  private isSearchingLocally: boolean = false;
  failedToDeleteSerials: FailedToDeleteSerial[] = [];
  showFailedDeleteModal: boolean = false;
  deleteSuccessCount: number = 0;
  showWeekColor: boolean = true;
  totalRecords: number = 0;
  pagesToShow: number[] = [];
  pageSizes = PageSizes;
  totalPages: number = 0;
  isDropdownOpen: boolean = false;
  currentPage: number = 1;
  itemsPerPage: number = this.pageSizes[0];

  constructor(
    private permissionService: NgxPermissionsService,
    private userservice: UserserviceService,
    private datepipe: DatePipe,
    private masterservice: MasterDataSeriveService,
    private breadcrumbService: BreadcrumbService,
    private toaster: CustomToastsService,
    private datePipe: DatePipe,
    private printersService: QzTrayService
  ) {}

  /*  showSuccess() {
      this.toaster.success('Delete successful!', 'Success', {
        timeOut: 1000,
      });
    }*/

  showSuccess() {
    this.toaster.success('Deleted Successfully');
  }

  async ngOnInit() {
    const user = this.masterservice.getUserDetailsFromStorage();
    const productionScheduleType = (user?.productionScheduleType ?? '')
      .toString()
      .trim()
      .toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';

    await this.printersService.initQZ();
    this.startDate = moment();
    this.endDate = moment();
    await this.getProductionHistory();
    this.breadcrumbService.updateActiveDeptTab('Home');

    // Setup debounced search
    this.searchSubject
      .pipe(
        debounceTime(500), // Wait 500ms after user stops typing
        distinctUntilChanged() // Only emit if value changed
      )
      .subscribe((searchTerm) => {
        this.performSearch(searchTerm);
      });
    this.breadcrumbService.updateActiveCategoryTab('History');
    //this.getPrintersList();
    this.getLabels();
    this.getPermissionsByUserId();
  }

  ngOnDestroy() {
    // Clean up the search subject to prevent memory leaks
    this.searchSubject.complete();
  }

  updateQty(workingTableID: number, qty: number) {
    this.disableEdit = !this.disableEdit;
  }

  toggleEditMode(index: number) {
    this.lastQty = this.DeptCatArray[index].qty;

    this.disableEdit = !this.disableEdit;
    this.editableRowIndex = this.editableRowIndex === index ? null : index;
  }

  cancel(index: number) {
    this.DeptCatArray[index].qty = this.lastQty;
    this.disableEdit = true;
    this.editableRowIndex = this.editableRowIndex === index ? null : index;
  }

  saveQty(index: number, wTbl: string, qty: number) {
    this.disableEdit = true;
    this.editableRowIndex = this.editableRowIndex === index ? null : index;
    this.getProductionHistory();
  }
  getLabels() {
    let userdata = this.masterservice.getUserDetailsFromStorage();
    let c_Id = userdata.companyID;
    this.masterservice.getAllLabels(c_Id).subscribe((res) => {
      const data: Labels[] = Array.isArray(res) ? res : [res];

      this.formatLabels = data.filter(
        (label) => label.labelEntityType === LabelEntityType.Product
      );
    });
  }

  deleteHistory() {
    this.masterservice.delHistory(this.printItems).subscribe(
      (res: any) => {
        const response = res as BulkDeleteHistoryResponse;
        const successCount = response.totalCount - response.failedToDeleteCount;

        this.breadcrumbService.decrement(successCount);
        this.printItems = [];
        this.deleteButtonClickedWithSelection = false;

        if (response.failedToDeleteCount === 0) {
          this.toaster.success(
            `All selected products were deleted successfully`
          );
          this.getProductionHistory();
        } else if (
          response.failedToDeleteCount > 0 &&
          response.failedToDeleteCount < response.totalCount
        ) {
          this.deleteSuccessCount = successCount;
          this.failedToDeleteSerials = response.failedToDeleteSerials;
          this.showFailedDeleteModal = true;
          this.getProductionHistory();
        } else {
          this.failedToDeleteSerials = response.failedToDeleteSerials;
          this.showFailedDeleteModal = true;
          this.getProductionHistory();
        }
      },
      (err: any) => {}
    );
  }

  closeFailedDeleteModal() {
    this.showFailedDeleteModal = false;
    this.failedToDeleteSerials = [];
    this.deleteSuccessCount = 0;
  }

  toggleCheckBox(event: any) {
    if (event.target.checked == true) {
      this.productionHistory.forEach((res) => {
        this.printItems.push(res.barcode);
        res.isPrintChecked = true;
      });
    } else {
      this.productionHistory.forEach((res) => {
        res.isPrintChecked = false;
      });
      this.printItems = [];
    }
    if (this.printItems.length == 0) {
      this.deleteButtonClickedWithSelection = false;
    } else {
      this.deleteButtonClickedWithSelection = true;
    }
  }

  toggleItem(barcodes: string) {
    if (this.printItems.includes(barcodes)) {
      const index = this.printItems.indexOf(barcodes);
      if (index !== -1) {
        this.printItems.splice(index, 1);
      }
    } else {
      this.printItems.push(barcodes);
    }
    if (this.printItems.length == 0) {
      this.deleteButtonClickedWithSelection = false;
    } else {
      this.deleteButtonClickedWithSelection = true;
    }
  }
  triggerTagButtonClick() {
    if (this.tagButton) {
      this.tagButton.nativeElement.click();
    }
  }
  async printMultiple() {
    if (this.printItems.length == 0) {
      this.isPrinting = true;
      this.triggerTagButtonClick();
    } else {
      this.isPrinting = false;
    }
    for (const res of this.printItems) {
      await this.printHistoryLabel(res);
    }
    this.printItems = [];
    this.productionHistory.forEach((item) => (item.isPrintChecked = false));
    this.DeptCatArray.forEach((item) => (item.isPrintChecked = false));
    this.getFilterData();
  }

  checkLabel(id: string) {
    this.printItems.push(id);
    this.printMultiple();
  }

  async printHistoryLabel(id: string) {
    await this.masterservice.printHistoryLabel(id, false).subscribe((res) => {
      this.printHistory = res as ProductionHistory[];
      let data = this.printHistory[0];
      this.printHistory.forEach((first, index) => {
        for (let i = 0; i < first.numberOfPieces; i++) {
          this.printerType = data.labelType;
          if (data.brandTypeId == 1) {
            const generatedData = this.generateEcomTag(
              data.departmentDescr,
              data.categoryName,
              data.brandDescr,
              data.price.toString(),
              '0',
              data.numberOfPieces.toString()
            );
          } else if (data.brandTypeId == 2) {
            const generatedData = this.generateBoutiqueTag(
              data.departmentDescr,
              data.categoryName,
              data.brandDescr,
              data.price.toString(),
              data.productionStoreId.toString(),
              data.totalQty.toString()
            );
          } else {
            this.activeTag = data.formatTypeId;
            let storeId = JSON.parse(localStorage.getItem('storeId')!);
            let zplData = this.generateZpl(
              data.companyName,
              data.departmentDescr,
              data.categoryName,
              data.subCategoryName,
              'Size:',
              data.sizeDescr,
              data.price.toFixed(2).toString(),
              data.barcode,
              storeId,
              data.qualityDescr,
              (i + 1).toString(),
              first.numberOfPieces.toString(),
              first.displayName,
              first?.weekNumber ?? 0,
              first.brandDescr
            );
            this.printLabel(zplData);
          }
        }
      });
    });
  }

  generateZpl(
    CompanyName: string,
    Department: string,
    Category: string,
    SubCategory: string,
    SizeText: string = 'Size',
    SizeSize: string,
    Price: string,
    BarcodeValue: string,
    CompanyNameLine2: string,
    qualityDescr: string = '',
    LabelIndex: string,
    Piece: string,
    colorName: string,
    weekNumber: number = 0,
    Brand: string = ''
  ) {
    if (SizeSize == null) {
      SizeText = ' ';
    }
    if (Department == Category) {
      Category = ' ';
    }

    function safeParse(value: string | null): string {
      try {
        return value ? JSON.parse(value) : '';
      } catch {
        return value ?? '';
      }
    }

    let storeRaw =
      localStorage.getItem('storeName') ??
      localStorage.getItem('defaultStoreName') ??
      '';
    let Store: string = safeParse(storeRaw);
    let colors = JSON.parse(localStorage.getItem('productionCycle') || '""');
    let Color = colorName;
    let WeekNumber = weekNumber.toString();
    if (
      Brand == null ||
      Brand == undefined ||
      Brand == 'None' ||
      Brand == 'Select Brand'
    ) {
      Brand = '';
    }
    let Date = '-';
    let Date2 = '-';
    const currentDate = moment();
    Date = currentDate.format('MM/DD');
    Date2 = currentDate.format('MM/DD/YYYY');
    const Time = currentDate.format('HH:mm');

    let userStorageData = this.masterservice.getUserDetailsFromStorage();
    const User = userStorageData?.brijjusername || '';
    const DisplayName = userStorageData?.displayName || '';

    this.formatLabels.map((res) => {
      if (res.id == this.activeTag) {
        this.previewZplCode = res.zplCode;
        this.previewTagSize = this.extractLabelSize(res.name);
      }
    });

    let QualityDescr = qualityDescr ? qualityDescr : '';

    if (typeof this.previewZplCode !== 'string') {
      console.error('Invalid or missing ZPL code');
      return [];
    }

    const replacedZplCode = this.previewZplCode
      .replace(/\${CompanyName}/g, CompanyName ? CompanyName : '')
      .replace(/\${Color}/g, Color ? Color : '')
      .replace(/\${WeekNumber}/g, WeekNumber ? WeekNumber : '')
      .replace(/\${Department}/g, Department ? Department : '')
      .replace(/\${Category}/g, Category ? Category : '')
      .replace(/\${SubCategory}/g, SubCategory ? SubCategory : '')
      .replace(/\${SizeText}/g, SizeText ? SizeText : '')
      .replace(/\${SizeSize}/g, SizeSize ? SizeSize : '')
      .replace(/\${Price}/g, Price ? Price : '')
      .replace(/\${Date}/g, Date ? Date : '')
      .replace(/\${Date2}/g, Date2 ? Date2 : '')
      .replace(/\${Time}/g, Time)
      .replace(/\${User}/g, User)
      .replace(/\${Name}/g, DisplayName)
      .replace(/\${DisplayName}/g, DisplayName)
      .replace(/\${BarcodeValue}/g, BarcodeValue ? BarcodeValue : '')
      .replace(/\${Store}/g, Store ? Store : '')
      .replace(/\${Quality}/g, QualityDescr ? QualityDescr : '')
      .replace(/\${LabelIndex}/g, LabelIndex ? LabelIndex : '')
      .replace(/\${Piece}/g, Piece ? Piece : '')
      .replace(/\${Brand}/g, Brand ? Brand : '')
      .replace(
        /\${CompanyNameLine2}/g,
        CompanyNameLine2 ? CompanyNameLine2 : ''
      );

    const zplTemplate: string[] = replacedZplCode
      .split('\n')
      .map((line) => line.trim());
    console.log(zplTemplate);
    return zplTemplate;
  }

  extractLabelSize(input: string): string {
    const labelNumber = input.match(/[0-9]+(\.[0-9]+)?/)?.[0] || '';
    const sizeNumber = input.match(/X\s?([0-9]+(\.[0-9]+)?)"/)?.[1] || '';

    let result = `${labelNumber}x${sizeNumber}`;
    return result;
  }

  async printTag(data: any) {
    let printerName: string = '';
    if (this.printersList.includes('ZebraTag')) {
      printerName = 'ZebraTag';
    } else {
      printerName = 'ZebraBoth';
    }
    let qty = this.printHistory[0].qty;
    qty = this.printHistory[0].numberPieces * qty;
    for (let i = 0; i < qty; i++) {
      let res = this.printersService.printData(printerName, data);
    }
  }

  async printLabel(data: any) {
    let printerName: string = '';

    if (this.printerType == 1) {
      printerName = 'ZebraLabel';
    } else if (this.printerType == 2) {
      printerName = 'ZebraTag';
    } else if (this.printerType == 3) {
      printerName = 'ZebraBoth';
    }
    let res = this.printersService.printData(printerName, data);
  }
  generateZPLTag(
    name: string,
    category: string,
    price: string,
    barcode: string
  ): string[] {
    const zplTemplate: string[] = [
      '^XA',
      '~TA000',
      '~JSN',
      '^LT0',
      '^MNW',
      '^MTD',
      '^PON',
      '^PMN',
      '^LH0,0',
      '^JMA',
      '^PR4,4',
      '~SD15',
      '^JUS',
      '^LRN',
      '^CI27',
      '^PA0,1,1,0',
      '^XZ',
      '^XA',
      '^MMT',
      '^PW406',
      '^LL203',
      '^LS0',
      `^FT29,45^A0N,37,38^FH^CI28^FD${name}^FS^CI27`,
      `^FT29,86^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
      `^FT29,155^A0N,37,38^FH^CI28^FD$ ${price}^FS^CI27`,
      `^FT280,181^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
      '^FT268,150^BON,5,8',
      `^FH^FD${barcode}^FS`,
      '^PQ1,0,1,Y',
      '^XZ'
    ];
    return zplTemplate;
  }

  generateEcomTag(
    department?: string,
    category?: string,
    brand?: string,
    price?: string,
    price2?: string,
    qty?: string
  ): string[] {
    const zplTemplate: string[] = [
      '^XA',
      '~TA000',
      '~JSN',
      '^LT0',
      '^MNW',
      '^MTD',
      '^PON',
      '^PMN',
      '^LH0,0',
      '^JMA',
      '^PR4,4',
      '~SD15',
      '^JUS',
      '^LRN',
      '^CI27',
      '^PA0,1,1,0',
      '^XZ',
      '^XA',
      '^MMT',
      '^PW305',
      '^LL508',
      '^LS0',
      `^FT44,150^A0N,28,28^FH^CI28^FDE-Commerce^FS^CI27`,
      `^FT44,200^A0N,22,22^FH^CI28^FD${department}/${category}^FS^CI27`,
      `^FT44,250^A0N,28,28^FH^CI28^FD${brand}^FS^CI27`,
      `^FT44,300^A0N,22,22^FH^CI28^FDGoodwill Finds $${price} ^FS^CI27`,
      `^FT44,335^A0N,22,22^FH^CI28^FDRCS AI Avg^FS^CI27`,
      `^FT185,335^A0N,22,22^FH^CI28^FD $ ${price2} ^FS^CI27`,
      `^FT44,400^A0N,22,22^FH^CI28^FDCurent OnHand^FS^CI27`,
      `^FT185,400^A0N,22,22^FH^CI28^FD: ${qty} ^FS^CI27`,
      '^PQ1,0,1,Y',
      '^XZ'
    ];
    this.printLabel(zplTemplate);
    return zplTemplate;
  }

  generateBoutiqueTag(
    department?: string,
    category?: string,
    brand?: string,
    price?: string,
    storeId?: string,
    qty?: string
  ): string[] {
    const zplTemplate: string[] = [
      '^XA',
      '~TA000',
      '~JSN',
      '^LT0',
      '^MNW',
      '^MTD',
      '^PON',
      '^PMN',
      '^LH0,0',
      '^JMA',
      '^PR4,4',
      '~SD15',
      '^JUS',
      '^LRN',
      '^CI27',
      '^PA0,1,1,0',
      '^XZ',
      '^XA',
      '^MMT',
      '^PW305',
      '^LL508',
      '^LS0',
      `^FT44,150^A0N,28,28^FH^CI28^FDBoutique Item^FS^CI27`,
      `^FT44,200^A0N,22,22^FH^CI28^FD${department}/${category}^FS^CI27`,
      `^FT44,250^A0N,28,28^FH^CI28^FD${brand}^FS^CI27`,
      `^FT44,300^A0N,22,22^FH^CI28^FDStoreID ^FS^CI27`,
      `^FT134,300^A0N,22,22^FH^CI28^FDQty ^FS^CI27`,
      `^FT184,300^A0N,22,22^FH^CI28^FDAvg Price^FS^CI27`,
      `^FT34,335^A0N,22,22^FH^CI28^FD ${storeId} ^FS^CI27`,
      `^FT124,335^A0N,22,22^FH^CI28^FD ${qty} ^FS^CI27`,
      `^FT184,335^A0N,22,22^FH^CI28^FD $ ${price} ^FS^CI27`,
      '^PQ1,0,1,Y',
      '^XZ'
    ];
    this.printLabel(zplTemplate);
    return zplTemplate;
  }

  generateZPLLabel(
    company: string,
    department: string,
    category: string,
    size: string,
    price: string,
    barcode: string
  ): string[] {
    if (size != null) {
      const zplTemplate: string[] = [
        '^XA',
        '~TA000',
        '~JSN',
        '^LT0',
        '^MNW',
        '^MTD',
        '^PON',
        '^PMN',
        '^LH0,0',
        '^JMA',
        '^PR4,4',
        '~SD15',
        '^JUS',
        '^LRN',
        '^CI27',
        '^PA0,1,1,0',
        '^XZ',
        '^XA',
        '^MMT',
        '^PW305',
        '^LL508',
        '^LS0',
        `^FT35,57^A0N,37,38^FH^CI28^FD${company}^FS^CI27`,
        `^FT54,144^A0N,28,28^FH^CI28^FD${department}^FS^CI27`,
        `^FT90,200^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
        `^FT90,250^A0N,24,18^FH^CI28^FDSize : ^FS^CI27`,
        `^FT131,248^A0N,24,32^FH^CI28^FD${size} ^FS^CI27`,
        `^FT90,299^A0N,28,38^FH^CI28^FD$ ${price} ^FS^CI27`,
        `^FT102,406^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
        `^BY1,3,61^FT69,377^BCN,,N,N`,
        `^FH^FD>${barcode}^FS`,
        '^PQ1,0,1,Y',
        '^XZ'
      ];
      return zplTemplate;
    } else {
      const zplTemplate: string[] = [
        '^XA',
        '~TA000',
        '~JSN',
        '^LT0',
        '^MNW',
        '^MTD',
        '^PON',
        '^PMN',
        '^LH0,0',
        '^JMA',
        '^PR4,4',
        '~SD15',
        '^JUS',
        '^LRN',
        '^CI27',
        '^PA0,1,1,0',
        '^XZ',
        '^XA',
        '^MMT',
        '^PW305',
        '^LL508',
        '^LS0',
        `^FT35,57^A0N,37,38^FH^CI28^FD${company}^FS^CI27`,
        `^FT54,144^A0N,28,28^FH^CI28^FD${department}^FS^CI27`,
        `^FT90,200^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
        `^FT90,250^A0N,28,38^FH^CI28^FD$ ${price} ^FS^CI27`,
        `^FT102,370^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
        `^BY1,3,61^FT69,330^BCN,,N,N`,
        `^FH^FD>${barcode}^FS`,
        '^PQ1,0,1,Y',
        '^XZ'
      ];
      return zplTemplate;
    }
  }

  generateZPLLabelLandscape(
    company: string,
    department: string,
    category: string,
    size: string,
    price: string,
    barcode: string
  ): string[] {
    if (size != null) {
      const zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0, 0`,
        `^JMA`,
        `^PR6, 6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0, 1, 1, 0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW508`,
        `^LL305`,
        `^LS0`,
        `^FT443,38^A0R,42,41^FH\^CI28^FD${company}^FS^CI27`,
        `^FT347,38^A0R,35,34^FH\^CI28^FD${department}^FS^CI27`,
        `^FT286,38^A0R,35,34^FH\^CI28^FD${category}^FS^CI27`,
        `^FT222,38^A0R,35,34^FH\^CI28^FDSize : ${size}^FS^CI27`,
        `^FT153,38^A0R,35,34^FH\^CI28^FDPrice : ^FS^CI27`,
        `^FT153,148^A0R,35,34^FH\^CI28^FD$^FS^CI27`,
        `^FT153,168^A0R,35,34^FH\^CI28^FD${price}^FS^CI27`,
        `^BY1,3,67^FT44,98^BCR,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^PQ1, 0, 1, Y`,
        `^XZ`
      ];
      return zplTemplate;
    } else {
      const zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0, 0`,
        `^JMA`,
        `^PR6, 6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0, 1, 1, 0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW508`,
        `^LL305`,
        `^LS0`,
        `^FT443,38^A0R,35,34^FH\^CI28^FD${company}^FS^CI27`,
        `^FT347,38^A0R,35,34^FH\^CI28^FD${department}^FS^CI27`,
        `^FT286,38^A0R,35,34^FH\^CI28^FD${category}^FS^CI27`,
        `^FT222,38^A0R,35,34^FH\^CI28^FDPrice : ^FS^CI27`,
        `^FT222,148^A0R,35,34^FH\^CI28^FD$^FS^CI27`,
        `^FT222,168^A0R,35,34^FH\^CI28^FD${price}^FS^CI27`,
        `^BY1,3,67^FT103,98^BCR,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^PQ1, 0, 1, Y`,
        `^XZ`
      ];
      return zplTemplate;
    }
  }

  generateSpokane(
    company: string,
    dept: string,
    category: string,
    Size: string,
    price: string,
    barcode: string
  ) {
    if (Size) {
      const zpltemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0,0`,
        `^JMA`,
        `^PR6,6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0,1,1,0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW559`,
        `^LL203`,
        `^LS0`,
        `^FT53,46^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT28,76^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT28,105^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^FT28,134^A0N,23,28^FH\^CI28^FDSize:${Size}^FS^CI27`,
        `^BY1,3,41^FT158,176^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT28,170^A0N,28,35^FH\^CI28^FD$1.99^FS^CI27`,
        `^FT322,47^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT298,77^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT298,106^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^FT298,135^A0N,23,28^FH\^CI28^FDSize:${Size}^FS^CI27`,
        `^BY1,3,41^FT428,177^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT298,172^A0N,28,35^FH\^CI28^FD$1.99^FS^CI27`,
        `^PQ1,0,1,Y`,
        `^XZ`
      ];
      return zpltemplate;
    } else {
      let zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0,0`,
        `^JMA`,
        `^PR6,6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0,1,1,0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW559`,
        `^LL203`,
        `^LS0`,
        `^FT53,46^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT28,76^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT28,105^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^BY1,3,41^FT158,176^BCN,,Y,N`,
        `^FH\^FD>;123456789012^FS`,
        `^FT28,170^A0N,28,35^FH\^CI28^FD$1.99^FS^CI27`,
        `^FT322,47^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT298,77^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT298,106^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^BY1,3,41^FT428,177^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT298,172^A0N,28,35^FH\^CI28^FD$1.99^FS^CI27`,
        `^PQ1,0,1,Y`,
        `^XZ`
      ];
      return zplTemplate;
    }
  }

  async getProductionHistory(
    pageNumber: number = 1,
    pageSize: number = this.itemsPerPage
  ) {
    this.isLoading = true;
    this.printItems = [];
    let user = this.masterservice.getUserDetailsFromStorage();
    let userID = user.userId;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    await this.masterservice
      .getHistoryByDateRange(
        userID,
        formattedStartDate,
        formattedEndDate,
        undefined,
        false,
        pageNumber,
        pageSize
      )
      .subscribe({
        next: (res: any) => {
          // API returns paginated response with totalCount, pageNumber, pageSize, items
          if (res && res.items && res.items.length > 0) {
            this.isHistory = true;
            this.productionHistory = res.items as ProductionHistory[];
            this.DeptCatArray = res.items as ProductionHistory[];
            this.searchBarcode = res.items as ProductionHistory[];
            this.DeptCatArray1 = res.items as ProductionHistory[];

            this.totalRecords = res.totalCount;
            this.currentPage = res.pageNumber;
            this.itemsPerPage = res.pageSize;
            this.updatePagination();

            // Reset isPrintChecked for all items
            this.productionHistory.forEach(
              (item) => (item.isPrintChecked = false)
            );
            this.DeptCatArray.forEach((item) => (item.isPrintChecked = false));
            this.getseparatedataforFilters();
          } else {
            this.isHistory = false;
            this.DeptCatArray = [];
            this.productionHistory = [];
            this.totalRecords = 0;
            this.updatePagination();
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  async delWorkingTbl(workingTbl: any) {
    this.masterservice.delHistory([workingTbl.toString()]).subscribe(
      (res: any) => {
        const response = res as BulkDeleteHistoryResponse;
        if (response.failedToDeleteCount === 0) {
          this.breadcrumbService.decrement(1);
          this.toaster.success(
            `All selected products were deleted successfully`
          );
          this.getProductionHistory();
          this.selectedIdToDelete = 0;
        } else {
          this.deleteSuccessCount = 0;
          this.failedToDeleteSerials = response.failedToDeleteSerials;
          this.showFailedDeleteModal = true;
          this.selectedIdToDelete = 0;
        }
      },
      (err: any) => {
        this.selectedIdToDelete = 0;
      }
    );
  }

  selectRecordToDelete(id: any) {
    this.selectedIdToDelete = id;
  }

  getseparatedataforFilters() {
    this.DeptArrayForDepartment = this.DeptCatArray1;
    this.DeptArrayForCategory = this.DeptCatArray1;
    this.DeptArrayForColors = this.DeptCatArray1;

    var filterArray = this.DeptArrayForDepartment.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.departmentId === current.departmentId
          )
        ) {
          current.isSelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );

    this.DeptCatArrayForFilters = filterArray;

    this.DeptArrayForDepartment = filterArray;

    var filterArray1 = this.DeptArrayForCategory.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.categoryId === current.categoryId
          )
        ) {
          current.cIsSelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );
    this.DeptArrayForCategory = filterArray1;

    var filterArray2 = this.DeptArrayForColors.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.productionCycleId === current.productionCycleId
          )
        ) {
          current.wIsSelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );
    this.DeptArrayForColors = filterArray2;
  }

  clearFilter(dta: any) {
    if (dta == 'Department') {
      this.filterDepartmentIDs = [];
      this.DeptCatArrayForFilters.forEach((el) => {
        el.isSelected = false;
      });
      this.selectedDeptForFiletr = [];
      this.selectedFilterCategory(dta);
    } else if (dta == 'Category') {
      this.filterCategoriesIDs = [];
      this.DeptCatArrayForFilters.forEach((el) => {
        el.cIsSelected = false;
      });
      this.selectedFilterCategory(dta);
    } else if (dta == 'Color') {
      this.filterColorIDs = [];
      this.DeptCatArrayForFilters.forEach((el) => {
        el.cIsSelected = false;
      });
      this.selectedFilterCategory(dta);
    } else if (dta == 'Dates') {
      this.startingDate = '';
      this.endingDate = '';
    } else if (dta == 'Print') {
      this.equalsZero = false;
      this.greaterZero = false;
      this.printCnt = false;
    }

    this.noData = false;
    this.getFilterData();
  }

  selectedFilterCategory(dta: any) {
    this.filterName = dta;
    if (dta == 'Department') {
      this.DeptCatArrayForFilters = this.DeptArrayForDepartment;
    } else if (dta == 'Category') {
      this.DeptCatArrayForFilters = this.DeptArrayForCategory;
      if (this.selectedDeptForFiletr.length) {
        this.DeptCatArrayForFilters = this.DeptCatArrayForFilters.filter(
          (item) => this.selectedDeptForFiletr.includes(item.departmentId)
        );
      }
    } else if (dta == 'Color') {
      this.DeptCatArrayForFilters = this.DeptArrayForColors;
    }
  }

  getFilterData() {
    const startDate = this.startingDate
      ? new Date(this.startingDate + 'T00:00:00Z')
      : null;
    const endDate = this.endingDate
      ? new Date(this.endingDate + 'T23:59:59Z')
      : null;
    if (this.startingDate == '' && this.endingDate == '') {
      this.showDates = false;
    } else {
      this.showDates = true;
    }

    if (startDate && endDate) {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
    }

    let filteredArray = this.DeptCatArray1.filter((item) => {
      const deptFilter =
        this.filterDepartmentIDs.length === 0 ||
        this.filterDepartmentIDs.includes(item.departmentId);
      const categoryFilter =
        this.filterCategoriesIDs.length === 0 ||
        this.filterCategoriesIDs.includes(item.categoryId);
      const colorFilter =
        this.filterColorIDs.length === 0 ||
        this.filterColorIDs.includes(item.productionCycleId);
      const dateFilter =
        !startDate ||
        !endDate ||
        (startDate <= new Date(item.dateCreated) &&
          new Date(item.dateCreated) <= endDate);
      return deptFilter && categoryFilter && colorFilter && dateFilter;
    });

    if (!this.printCnt) {
      this.equalsZero = true;
      this.greaterZero = true;
    }

    if (this.equalsZero && this.greaterZero) {
    } else if (this.equalsZero) {
      let process = filteredArray;
      filteredArray = process.filter((res) => res.printCnt == 0);
    } else if (this.greaterZero) {
      let process = filteredArray;
      filteredArray = process.filter((res) => res.printCnt > 0);
    }

    if (
      this.filterDepartmentIDs.length === 0 &&
      this.filterCategoriesIDs.length === 0
    ) {
      this.noData = false;
    } else if (filteredArray.length == 0) {
      this.DeptCatArray = filteredArray;
      this.noData = true;
    }

    this.DeptCatArray = filteredArray;
    this.currentPage = 1;
    this.updatePagination();

    this.productionHistory = filteredArray;
    if (!this.printCnt) {
      this.printCnt = !this.printCnt;
      this.equalsZero = false;
      this.greaterZero = false;
    }
  }

  collectFilterParameters(search: any) {
    this.DeptCatArrayForFilters.forEach((elements: ProductionHistory) => {
      if (this.filterName === 'Department' && elements.departmentId == search) {
        elements.isSelected = !elements.isSelected;
        if (elements.isSelected) {
          this.selectedDeptForFiletr.push(search);
        } else {
          this.selectedDeptForFiletr = this.selectedDeptForFiletr.filter(
            (item) => item != search
          );
        }
      } else if (
        this.filterName === 'Category' &&
        elements.categoryId == search
      ) {
        elements.cIsSelected = !elements.cIsSelected;
      } else if (
        this.filterName === 'Color' &&
        elements.productionCycleId == search
      ) {
        elements.wIsSelected = !elements.wIsSelected;
      }
    });

    if (this.filterName === 'Department') {
      this.toggleFilterParameter(this.filterDepartmentIDs, search);
    } else if (this.filterName === 'Category') {
      this.toggleFilterParameter(this.filterCategoriesIDs, search);
    } else if (this.filterName === 'Color') {
      this.toggleFilterParameter(this.filterColorIDs, search);
    }
  }

  toggleFilterParameter(filterArray: any[], search: any) {
    const index = filterArray.indexOf(search);
    if (index !== -1) {
      filterArray.splice(index, 1);
    } else {
      filterArray.push(search);
    }
  }
  filterPrint(type: number) {
    if (type == 0) {
      this.equalsZero = !this.equalsZero;
    }
    if (type == 1) {
      this.greaterZero = !this.greaterZero;
    }
  }
  search() {
    // Trigger debounced search
    this.searchSubject.next(this.barcodes);
  }

  private performSearch(searchTerm: string) {
    if (searchTerm == '') {
      this.currentPage = 1;
      this.getProductionHistory(1, this.itemsPerPage);
      return;
    }

    this.currentPage = 1;
    this.searchFromAPI(searchTerm, 1);
  }

  private searchFromAPI(searchTerm: string, pageNumber: number = 1) {
    this.isLoading = true;

    // A barcode search spans the whole company and is not date-bounded: a ripped or
    // misprinted tag has to be findable and reprintable by someone other than the user
    // who produced it. Passing no userId and no dates leaves the API filtering on
    // CompanyId (from the token) and the barcode alone.
    this.masterservice
      .getHistoryByDateRange(
        undefined,
        null,
        null,
        searchTerm,
        false,
        pageNumber,
        this.itemsPerPage
      )
      .subscribe({
        next: (res: any) => {
          if (res && res.items && res.items.length > 0) {
            this.isHistory = true;
            this.productionHistory = res.items as ProductionHistory[];
            this.DeptCatArray = res.items as ProductionHistory[];
            this.searchBarcode = res.items as ProductionHistory[];
            this.DeptCatArray1 = res.items as ProductionHistory[];

            // Set pagination values from API response
            this.totalRecords = res.totalCount;
            this.currentPage = res.pageNumber;
            this.itemsPerPage = res.pageSize;
            this.updatePagination();

            this.productionHistory.forEach(
              (item) => (item.isPrintChecked = false)
            );
            this.DeptCatArray.forEach((item) => (item.isPrintChecked = false));
            this.getseparatedataforFilters();
          } else {
            this.isHistory = false;
            this.DeptCatArray = [];
            this.totalRecords = 0;
            this.updatePagination();
          }
        },
        error: (err) => {
          console.error('Search API error:', err);
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  searcha(event: KeyboardEvent) {
    // Trigger debounced search on every keystroke
    this.search();
  }

  /*date range picker */

  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel'
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,
    maxDate: new Date(),
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'This Week': [moment().startOf('week'), moment()],
      'Last Week': [
        moment().subtract(1, 'week').startOf('week'),
        moment().subtract(1, 'week').endOf('week')
      ],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month')
      ]
    },
    opens: 'left'
  };

  public async selectedDate(value: any) {
    // this is the date  selected
    this.endDate = value.end._d;
    this.startDate = value.start._d;
    await this.getProductionHistory();
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  getPermissionsByUserId() {
    this.userservice.getUserRolesandPerm().then((res) => {
      let permissions = res as UserPermissionsModel[];

      let perm: string[] = [];

      permissions?.forEach((pr) => {
        perm.push(pr.name);
      });

      this.permissionService.loadPermissions(perm);
    });
  }
  openFilterModal(modalState: string): void {
    if (modalState === 'Open') {
      this.isFilterModalOpen = true;
    }

    if (modalState === 'Close') {
      this.isFilterModalOpen = false;

      // Clear filter ID arrays
      this.filterDepartmentIDs = [];
      this.filterCategoriesIDs = [];
      this.filterColorIDs = [];

      // Reset selection flags on filter arrays
      (this.DeptCatArrayForFilters || []).forEach(
        (el: any) => (el.isSelected = false)
      );
      (this.DeptCatArrayForFilters || []).forEach(
        (el: any) => (el.cIsSelected = false)
      );
      (this.DeptCatArrayForFilters || []).forEach(
        (el: any) => (el.wIsSelected = false)
      );
      this.getFilterData();
    }
  }

  get pagedData(): ProductionHistory[] {
    // Data is already paginated from API, return it directly
    return this.DeptCatArray;
  }

  private updatePagination() {
    // Calculate total pages from totalRecords
    this.totalPages = Math.ceil(this.totalRecords / this.itemsPerPage);
    // build pagesToShow: up to 5 page numbers around currentPage
    const pages: number[] = [];
    const start = Math.max(1, this.currentPage - 2);
    const end = Math.min(this.totalPages, this.currentPage + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    this.pagesToShow = pages;
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getProductionHistory(page, this.itemsPerPage);
  }

  onItemsPerPageChange(size: number) {
    this.itemsPerPage = size;
    this.currentPage = 1;
    this.getProductionHistory(1, size);
  }
}
